import React from 'react';

export const RecentEducationTrainingTitle = (
  <p>
    In the time <strong>since you became too disabled to work</strong>, have you
    had any education or training?
  </p>
);
